/**
 * Reserved-account catalog — the authoritative list of system-reserved accounts
 * (tag → canonical code/name/type/parent), served from the backend registry so the
 * client can't drift. GET /reserved-accounts.
 */
import type { AccountType } from '../constants/labels';
import type { ReservedAccountCode } from '../constants/reserved-account-codes';

import { get } from './api-client';

interface ReservedAccountsResponse {
  reservedAccounts: Array<{
    systemTag: string;
    code: string;
    defaultName: string;
    accountSubtype: string;
    accountType: AccountType;
    parentCode: string;
  }>;
}

/** Fetch the canonical reserved-account catalog. */
export async function getReservedAccounts(): Promise<ReservedAccountCode[]> {
  const res = await get<ReservedAccountsResponse>('/reserved-accounts');
  return (res.data?.reservedAccounts ?? []).map(r => ({
    code: r.code,
    accountType: r.accountType,
    accountSubtype: r.accountSubtype,
    parentCode: r.parentCode,
    defaultName: r.defaultName,
    systemTag: r.systemTag,
    purpose: r.defaultName,
  }));
}
